import React, { useState } from 'react';
import { colors, typography } from '@99designs/ui/settings';
import styled from 'styled-components';
import { Input, InputProps } from '@99designs/ui';

type PasswordInputProps = Omit<InputProps, 'type'>;

const ToggleVisibilityButton = styled.button`
    color: ${colors.fiftyFirstShade};
    font-size: ${typography.typeScale.size2}px;
    font-weight: ${typography.fontWeights.bold};

    border: none;
    background-color: transparent;
    padding: 0;
`;

export const PasswordField = React.forwardRef(function PasswordField(
    fieldProps: PasswordInputProps,
    ref: React.RefObject<HTMLInputElement>
) {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        setIsVisible((visible) => !visible);
    };
    return (
        <Input
            ref={ref}
            type={isVisible ? 'text' : 'password'}
            suffix={
                <ToggleVisibilityButton type="button" onClick={toggleVisibility}>
                    {isVisible ? __('HIDE') : __('SHOW')}
                </ToggleVisibilityButton>
            }
            {...fieldProps}
        />
    );
});

export default PasswordField;
